import jApi from './jApi';

export default {
  getListCanvas(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/canvas/fetch', { params })
      .then(res => res);
  },

  getDetailCanvas(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/canvas/fetch', { params })
      .then(res => res);
  },

  getListUser(params) {
    const api = jApi.generateApi();
    return api.post('/user/employee/list-with-pagination', params)
      .then(res => res.data);
  },

  createCanvas(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/canvas/set', req)
      .then(res => res.data);
  },

  deleteCanvas(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/canvas/delete', { params })
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiCanvas.js